import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from "../../../../providers/appProvider"

import Modal from '../../../UI/Modal/Modal'
import Attachment from "../../../../assets/Icon/Attachment"; 
import tbl from '../../../../assets/Style/Table.module.css' 
import css from './Receipt.module.css'
 import Remove from "../../../../assets/Icon/Remove";
import { useReceipt } from '../../../../hooks/useReceipt';
import { baseFileURL } from '../../../../Api';

const Receipt = ({car,  carService}) => {

    const {app} = useContext(AppContext);
 
    const formatDate = (dateString) => {

        const purchasedAtDate = new Date(dateString);

        const months = [
            "იან",
            "თებ",
            "მარ",
            "აპრ",
            "მაი",
            "ივნ",
            "ივლ",
            "აგვ",
            "სექ",
            "ოქტ",
            "ნოე",
            "დეკ"
        ];

        const day = purchasedAtDate.getDate();
        const month = months[purchasedAtDate.getMonth()];
        const year = purchasedAtDate.getFullYear();

        return `${day} ${month}  ${year}`;
    };
 
    const [file, setFile] = useState("null");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {receiptService} = useReceipt()
 
    const [newReceipt, setNewReceipt] = useState({
        description: "",
        car_id: car.id,
        type_id: 3,
    })
 
    const [receipts, setReceipts] = useState([])

    const fetchReceipts = () => {
        receiptService.fetchByCarId(car.id)
            .then(receipts => {
                setReceipts(receipts)
            })
            .catch(error => { 
            });
    }

    useEffect(() => {

        fetchReceipts()
        
        if (isModalOpen) {
            fetchReceipts()
        }
    }, [isModalOpen]);
 
   
    const handleChange = (event) => {
  
        setNewReceipt({
            ...newReceipt,
            [event.target.name]: event.target.value
        });
    };

 
  
    const openModal = () => {
 
        setNewReceipt({
            ...newReceipt, 
            description: "",
            car_id: car.id,
            type_id: 3,
        });

        setIsModalOpen(true) 

    }

    const onAdd = () => {
        const newForm = new FormData();

        for (let key in newReceipt) {
            newForm.append(key, newReceipt[key]);
        }

        newForm.append('doc', file);


        receiptService.addReceiptCar(newForm)
            .then(response => {
                fetchReceipts()
                carService.fetchList()

            })
            .catch(error => {
                console.error(error);
            });

        setIsModalOpen(false)
         
    }
 
    const onRemove = (receiptId) => {
        receiptService.removeReceipt(receiptId)
            .then(response => {
                fetchReceipts()
                carService.fetchList() 
            })
            .catch(error => {
                console.error(error);
            });
    }

  
    return (
        <>
 
            {receipts.length > 0 ? (
                <div className={css.invoicebtn + ' ' + css.green} onClick={() => { openModal() }} >
                    <Attachment />   <span>{receipts.length}</span> 
                </div>
            ) : (
                <div className={css.invoicebtn} onClick={() => { openModal() }} >
                    <Attachment />  
                </div>
            )}
   
            <Modal isOpen={isModalOpen} size="medium" onClose={() => setIsModalOpen(false)}>

                <div className={css.modalHead} >
                    <h3>
                        <span className={css.iconHead} > <Attachment /></span>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ lineHeight: 1, fontSize: '14px', fontWeight: 600 }}>ინვოისები</div>    
                            <div style={{ lineHeight: 1, fontSize: '14px', fontWeight: 600, marginTop: '5px' }}> {car.name}</div>    
                        </div>
                         
                    </h3>
                </div>

                <div>
                    <div className={tbl.table + ' ' + css.table} style={{ minHeight: 'unset' }}>

                        <table>
                            <thead>
                                <tr>
                                    <th className={css.id}>#</th>
                                    <th>ინვოისი</th> 
                                    <th>ფაილი</th>
                                    <th>თარიღი</th> 
                                    <th>მომხმარებელი</th>
                                    <th className={css.btntbl}> </th>
                                </tr>
                            </thead>
                            <tbody>

                                {receipts.map((receipt, index) =>
                                    <tr key={receipt.id}>
                                        <td className={css.id}>{index + 1}</td>
                                        <td> {receipt.description}</td>
                                        <td>
                                            {
                                                receipt.doc === 'null' || receipt.doc &&
                                                <a href={baseFileURL + receipt.doc} target='_blank' rel="noopener noreferrer">
                                                    ფაილი
                                                </a>
                                            }
                                        </td>
                                        <td> {formatDate(receipt.created_at)} </td>
                                     

                                        <td> 
                                        {receipt.user ? (
                                            <span>{receipt.user.firstname} {receipt.user.lastname}</span>
                                        ) : (
                                            <span>N/A</span>
                                        )}
                                        </td>

                                        <td className={css.btntbl}>
                                            {app.hasPermission("COMPANY_INVOICE_DELETE") &&
                        
                                                <div className={css.btns}>
                                                    <div>
                                                        <span className={css.removeBtn} onClick={() => onRemove(receipt.id)} ><Remove /> წაშლა</span>
                                                    </div>
                                                </div>
                                            }
                                        </td>

                                    </tr>
                                )}
                            </tbody>
                        </table>

 
                    </div>
                    {app.hasPermission("COMPANY_INVOICE_ADD") &&
                                                  

                        <div className={css.formField}>

                            <legend>ინვოისის დამატება</legend>

                            <div className={css.row}> 
    
                                <div style={{ width: '100%' }}> 
                                    <div className={css.uploadDiv}>
                                        <input type="file" name="doc" onChange={e => setFile(e.target.files[0])} />
                                    </div>
                                </div> 
                                
    
                                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '15px'}}> 
                                    <label htmlFor="name">ინვოისის ID</label>                                      
                                    <input type="text" className={css.input} name="description"  onChange={handleChange} value={newReceipt.name} /> 
                                </div>

                            </div>

                            <div className={css.addBox}>
                                <span onClick={onAdd} className={css.addBtn}>დამატება</span>
                            </div>

                        </div>

                    } 
                </div>
            </Modal>
        </>
    );
};

export default Receipt;